<template>
  <a-layout id="components-layout-demo-side" style="min-height: 100vh">
    <a-layout-sider v-model="collapsed" :trigger="null" collapsible width="210" class="sider">
      <a-menu mode="inline" :selected-keys="siderKey" :style="{ height: '100%', borderRight: 0 }" @click="navbar"
        theme="dark">
        <template v-for="item in navbars">
          <a-sub-menu :key="item.navbarKey">
            <span slot="title">
              <a-icon :type="item.icon" style="font-size: 22px"></a-icon>
              <span>{{ item.navbarName }}</span>
            </span>
            <template v-for="sub in getSubmenuData(item.navbarKey)">
              <a-menu-item :key="sub.navbarKey">
                <router-link :to="sub.navbarPath">{{
                  sub.navbarName
                  }}</router-link>
              </a-menu-item>
            </template>
          </a-sub-menu>
        </template>
      </a-menu>
    </a-layout-sider>
    <a-layout>
      <a-layout-header style="background: #fff; padding: 0">
        <a-icon class="trigger" :type="collapsed ? 'menu-unfold' : 'menu-fold'"
          @click="() => (collapsed = !collapsed)" />
        <div class="logo" @click="goDefaultView">
          <!-- <a-icon type="money-collect" theme="filled" /> -->
          <img style="width: 30px; height: 30px; margin-bottom: 2%;" src="../assets/png/LOGO.png">
          {{ SiteCode }}-活动系统后台
          <!-- DEMO-活动系统后台 -->
        </div>

        <div class="header-center-content">
          <a-space :size="18">
            <a-badge :count="Count.borrowCount" v-if="Role.borrowRole">
              <a-tooltip title="借款订单" placement="bottomLeft">
                <a href="javascript:;" @click="hrefroute(0)"><a-avatar shape="square" size="large">
                    <span style="color: black; font-size: 30px">借</span>
                    <a-icon style="color: black; font-size: 30px" type="dollar" /> </a-avatar></a>
              </a-tooltip>
            </a-badge>
            <a-badge :count="Count.repayCount" v-if="Role.repayRole">
              <a-tooltip title="还款订单" placement="bottomLeft">
                <a href="javascript:;" @click="hrefroute(1)"><a-avatar shape="square" size="large">
                    <span style="color: black; font-size: 30px">还</span>
                    <a-icon style="color: black; font-size: 30px" type="dollar" /> </a-avatar></a>
              </a-tooltip>
            </a-badge>
            <a-badge :count="Count.PromotionsApplyCount" v-if="Role.promotionRole">
              <a-tooltip title="活动申请" placement="bottomLeft">
                <a href="javascript:;" @click="hrefroute(2)"><a-avatar shape="square" size="large">
                    <span style="color: black; font-size: 30px">活动</span>
                  </a-avatar></a>
              </a-tooltip>
            </a-badge>
            <a-badge :count="Count.ATUserVerifiedCount" v-if="Role.ATUserVerifiedRole">
              <a-tooltip title="会员账号核实" placement="bottomLeft">
                <a href="javascript:;" @click="hrefroute(3)">
                  <a-avatar shape="square" size="large">
                    <span style="color: black; font-size: 10px">
                      <div class="avatar_name">账号<br>核实</div>
                    </span>
                  </a-avatar></a>
              </a-tooltip>
            </a-badge>
            <a-badge :count="Count.ATSaleUserCount" v-if="Role.ATSaleUserRole">
              <a-tooltip title="出售账号" placement="bottomLeft">
                <a href="javascript:;" @click="hrefroute(4)"><a-avatar shape="square" size="large">
                    <span style="color: black; font-size: 10px">
                      <div class="avatar_name">出售<br>账号</div>
                    </span>
                  </a-avatar></a>
              </a-tooltip>
            </a-badge>
            <a-badge :count="Count.ATSaleListCount" v-if="Role.ATSaleListRole">
              <a-tooltip title="出价列表" placement="bottomLeft">
                <a href="javascript:;" @click="hrefroute(5)"><a-avatar shape="square" size="large">
                    <span style="color: black; font-size: 10px">
                      <div class="avatar_name">出价<br>列表</div>
                    </span>
                  </a-avatar></a>
              </a-tooltip>
            </a-badge>
            <a-badge :count="Count.ATUserEvaluationCount" v-if="Role.ATUserEvaluationRole">
              <a-tooltip title="评估账号" placement="bottomLeft">
                <a href="javascript:;" @click="hrefroute(6)"><a-avatar shape="square" size="large">
                    <span style="color: black; font-size: 10px">
                      <div class="avatar_name">评估<br>账号</div>
                    </span>
                  </a-avatar></a>
              </a-tooltip>
            </a-badge>
            <a-badge :count="Count.ATUserRecoveryCount" v-if="Role.ATUserRecoveryRole">
              <a-tooltip title="回收账号" placement="bottomLeft">
                <a href="javascript:;" @click="hrefroute(7)"><a-avatar shape="square" size="large">
                    <span style="color: black; font-size: 10px">
                      <div class="avatar_name">回收<br>账号</div>
                    </span>
                  </a-avatar></a>
              </a-tooltip>
            </a-badge>
            <a-icon v-if="
                Role.borrowRole ||
                Role.repayRole ||
                Role.promotionRole ||
                Role.ATUserVerifiedRole ||
                Role.ATSaleUserRole ||
                Role.ATSaleListRole ||
                Role.ATUserEvaluationRole ||
                Role.ATUserRecoveryRole
              " type="reload" style="color: black; font-size: 25px; padding-top: 25px" @click="getOrderCount" />
          </a-space>
        </div>
        <div class="header-right-content">
          <a-dropdown placement="bottomRight">
            <span class="ant-pro-account-avatar">
              <a-button type="primary" shape="circle">
                <a-icon style="font-size: 15pt" type="home" />
              </a-button>
            </span>
            <template v-slot:overlay>
              <a-menu class="ant-pro-drop-down menu" :selected-keys="[]">
                <a-menu-item key="settings" @click="showDrawer">
                  <a-icon type="setting" />
                  修改个人密码
                </a-menu-item>
                <a-menu-divider />
                <a-menu-item key="googleVerify">
                  <router-link to="googleverify">
                    <a-icon type="chrome" />
                    &nbsp;&nbsp;Google二次验证器
                  </router-link>
                </a-menu-item>
                <a-menu-item key="logout" @click="handleLogout">
                  <a-icon type="logout" />
                  退出登录
                </a-menu-item>
              </a-menu>
            </template>
          </a-dropdown>
          <div class="userTemp">HI, {{ UserID }}</div>
        </div>
      </a-layout-header>
      <a-layout-content style="margin: 0 16px">
        <a-breadcrumb class="breadcrumb" separator=">">
          <a-breadcrumb-item v-for="(item, index) in $route.meta.breadcrumb" :key="index">{{ item }}</a-breadcrumb-item>
        </a-breadcrumb>
        <div :style="{ padding: '24px', background: '#fff', minHeight: '360px' }">
          <keep-alive>
            <router-view></router-view>
          </keep-alive>
        </div>
      </a-layout-content>
      <a-layout-footer style="text-align: center">
        Design ©2022 Created by GT (Version 1.0.0)
      </a-layout-footer>
    </a-layout>

    <a-drawer title="修改个人密码" :width="250" :visible="visible" :body-style="{ paddingBottom: '80px' }" @close="onClose">
      <a-form :form="form" layout="vertical" hide-required-mark>
        <a-row :gutter="16">
          <a-col :span="24">
            <a-form-item label="原密码">
              <a-input-password v-model="editPara.txt_password" type="password" autocomplete="off" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="24">
            <a-form-item label="新密码">
              <a-input-password v-model="editPara.txt_password1" type="password" autocomplete="off"
                @change="clearpwd2" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter="16">
          <a-col :span="24">
            <a-form-item label="确认新密码">
              <a-input-password v-model="editPara.txt_password2" type="password" autocomplete="off" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <div :style="{
          position: 'absolute',
          right: 0,
          bottom: 0,
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1,
        }">
        <a-button :style="{ marginRight: '8px' }" @click="onClose">
          关闭
        </a-button>
        <a-button type="primary" @click="EditPwd"> 确认修改 </a-button>
      </div>
    </a-drawer>
  </a-layout>
</template>


<script>
  export default {
    data() {
      return {
        Role: {
          borrowRole: false,
          repayRole: false,
          promotionRole: false,
          ATUserVerifiedRole: false,
          ATSaleUserRole: false,
          ATSaleListRole: false,
          ATUserEvaluationRole: false,
          ATUserRecoveryRole: false,
        },
        Count: {
          borrowCount: 0,
          repayCount: 0,
          PromotionsApplyCount: 0,
          ATUserVerifiedCount: 0,
          ATSaleUserCount: 0,
          ATSaleListCount: 0,
          ATUserEvaluationCount: 0,
          ATUserRecoveryCount: 0,
        },
        collapsed: false,
        contentComponent: null,
        clickKey: "",
        menuidx: "1",
        siderKey: ["1_1"],
        UserID: sessionStorage.UserID,
        SiteCode: sessionStorage.Code,
        navbars: [],
        navbarItems: [],
        form: this.$form.createForm(this),
        visible: false,
        editPara: {
          txt_password: "",
          txt_password1: "",
          txt_password2: "",
        },

        polling: null,
      };
    },
    methods: {
      getSubmenuData(input) {
        const retItems = [];
        for (const item in this.navbarItems) {
          if (this.navbarItems[item].navbarKey.split("_")[0] == input) {
            retItems.push(this.navbarItems[item]);
          }
        }
        return retItems;
      },
      navbar(input) {
        this.menuidx = input.key;
      },
      showDrawer() {
        this.visible = true;
      },
      onClose() {
        this.visible = false;
      },
      EditPwd() {
        if (this.editPara.txt_password1 != this.editPara.txt_password2) {
          this.$message.error("密码与确认密码不一致!");
          return false;
        }

        const _this = this;
        this.$confirm({
          title: "是否要修改个人密码?",
          content: "是否要修改个人密码?",
          onOk() {
            const params = {
              OldPassWord: _this.editPara.txt_password,
              NewPassWord: _this.editPara.txt_password1,
            };

            const postUrl = "/mgruser/editmgruserpwd";

            _this.axios.post(postUrl, params).then((res) => {
              if (res.data) {
                _this.$message.success("修改密码成功!");
                sessionStorage.clear();
                _this.$router.push("login");
              } else {
                _this.$message.error(res.error);
              }
            });
          },
          onCancel() { },
        });
      },
      handleLogout(e) {
        const _this = this;
        this.$confirm({
          title: "是否要登出?",
          content: "请确认是否要登出?",
          onOk() {
            _this.axios.post("/home/logout", "").then((res) => {
              sessionStorage.clear();
              _this.polling = clearInterval(_this.polling);
              _this.$router.push("login");
            });
          },
          onCancel() { },
        });
      },
      clearpwd2() {
        this.editPara.txt_password2 = "";
      },
      goDefaultView(e) {
        if (this.$route.path != "/default") {
          this.$router.push("default");
        }
      },
      SelectMenu() {
        // 选中侧栏导航
        const routes = this.$route.matched.concat().pop();
        this.siderKey = [routes.meta.navbarKey];
      },
      getMenuList() {
        const roleitem = [];
        this.axios.post("/role/getmenu", "").then((res) => {
          if (res.data) {
            for (let i = 0; i < res.data.length; i++) {
              if (res.data[i].Level === 0) {
                this.navbars.push({
                  navbarKey: res.data[i].Index,
                  navbarName: res.data[i].Name,
                  icon: res.data[i].Icon,
                  index: res.data[i].Index,
                });
              } else if (res.data[i].Level === 1) {
                switch (res.data[i].Index) {
                  //是否有开启该列表权限
                  case 7:
                    this.Role.borrowRole = true;
                    break;
                  case 62:
                    this.Role.repayRole = true;
                    break;
                  case 128:
                    this.Role.promotionRole = true;
                    break;
                  case 132:
                    this.Role.ATUserVerifiedRole = true;
                    break;
                  case 130:
                    this.Role.ATSaleUserRole = true;
                    break;
                  case 137:
                    this.Role.ATSaleListRole = true;
                    break;
                  case 133:
                    this.Role.ATUserEvaluationRole = true;
                    break;
                  case 134:
                    this.Role.ATUserRecoveryRole = true;
                    break;
                }

                this.navbarItems.push({
                  navbarKey: `${res.data[i].Parents}_${res.data[i].Index}`,
                  navbarName: res.data[i].Name,
                  navbarPath: res.data[i].Icon,
                  index: res.data[i].Index,
                });
              } else if (res.data[i].Level === 2) {
                roleitem.push(res.data[i].Index);
              }
            }
            sessionStorage.setItem("RoleID", JSON.stringify(roleitem));
          } else {
          }
        });
      },
      getOrderCount() {
        this.axios.post("/usermember/getordercount", "").then((res) => {
          if (res.data) {
            this.Count.borrowCount = res.data[0].BorrowCount;
            this.Count.repayCount = res.data[0].RepayCount;
            this.Count.PromotionsApplyCount = res.data[0].PromotionsApplyCount;
            this.Count.ATUserVerifiedCount = res.data[0].ATUserVerifiedCount;
            this.Count.ATSaleUserCount = res.data[0].ATSaleUserCount;
            this.Count.ATSaleListCount = res.data[0].ATSaleListCount;
            this.Count.ATUserEvaluationCount = res.data[0].ATUserEvaluationCount;
            this.Count.ATUserRecoveryCount = res.data[0].ATUserRecoveryCount;
            sessionStorage.setItem("BorrowMin", res.data[0].BorrowMin);
            sessionStorage.setItem("RepayMin", res.data[0].RepayMin);
          }
        });
      },
      pollData() {
        this.polling = setInterval(() => {
          this.getOrderCount();
        }, 300 * 1000);
      },
      hrefroute(flag) {
        //0:借款订单 1:还款订单 2:活动申请 3:会员账号 4:出售账号 5:出价列表 6:评估账号 7:回收账号
        if (flag == 0) {
          if (this.$route.path != "/borroworder") {
            this.$router.push("borroworder");
          }
        } else if (flag == 1) {
          if (this.$route.path != "/repayorder") {
            this.$router.push("repayorder");
          }
        } else if (flag == 2) {
          if (this.$route.path != "/activieapply") {
            this.$router.push({
              name: "activieapply",
              params: { State: "1" },
            });
          }
        } else if (flag == 3) {
          if (this.$route.path != "/accountuser") {
            this.$router.push("accountuser");
          }
        } else if (flag == 4) {
          if (this.$route.path != "/saleuserlist") {
            this.$router.push({
              name: "saleuserlist",
              params: { State: "1" },
            });
          }
        } else if (flag == 5) {
          if (this.$route.path != "/salelist") {
            this.$router.push({
              name: "salelist",
              params: { State: "1" },
            });
          }
        } else if (flag == 6) {
          if (this.$route.path != "/accountevaluation") {
            this.$router.push({
              name: "accountevaluation",
              params: { State: "1" },
            });
          }
        } else if (flag == 7) {
          if (this.$route.path != "/accountrecovery") {
            this.$router.push({
              name: "accountrecovery",
              params: { State: "1" },
            });
          }
        }
      },
      changeSiteCodeName() {
        if (this.SiteCode == "SDYLBB") {
          this.SiteCode = "SDYL-必贏"
        }
        else if (this.SiteCode == "SDYLJS") {
          this.SiteCode = "SDYL-JS"
        }
      },

    },
    // 参数监听
    watch: {
      $route(val) {
        this.SelectMenu();
      },
    },
    created() {
      this.getOrderCount();
      this.getMenuList();
      this.pollData();
      this.changeSiteCodeName();
      // 初始化
      const routes = this.$route.matched.concat().pop();
      if (routes.path === "/index") {
        // 初次跳转到mgruser页面
        this.$router.push("default");
      }
    },
  };
</script>

<style>
  .logo {
    width: 330px;
    height: 36px;
    color: #40a9ff;
    margin: 16px 28px 16px 13px;
    float: left;
    font-size: 18pt;
    line-height: 36px;
    padding-left: 2px;
  }

  .ant-layout-header {
    background: rgb(220, 220, 220);
  }

  .breadcrumb {
    font-size: 15px;
    font-weight: 40px;
    margin: 10px 10px;
  }

  .siderClass {
    background: rgb(180, 180, 180);
  }

  .header-right-content {
    display: flex;
    float: right;
    margin-right: 50px;
  }

  .userTemp {
    font-weight: bold;
    margin-left: 5px;
  }

  .header-center-content {
    float: left;
    font-size: 12pt;
  }

  .orderStyle {
    font-weight: bold;
  }

  .trigger {
    font-size: 18px;
    margin: 3px 1px 16px 13px;
    line-height: 68px;
    cursor: pointer;
    transition: color 0.3s;
    float: left;
  }

  .sider {
    overflow: scroll;
    height: 100vh;
    overflow-x: hidden;
  }

  .avatar_name {
    line-height: 15px;
    margin-top: 5px;
  }
</style>


// WEBPACK FOOTER //
// src/components/index.vue